import $ from 'jquery';

export function initYouTube() {

    var feeds_initialized = 0;

    // AS: create youtubeManager when the feed is initialized for the first time
    $(".zmpcm-feed").on("zmp-feed-initialized", function () {

        feeds_initialized++;

        if ($(".zmpcm-feed").length == feeds_initialized) {
            $("body").youtubeManager({
                playerWidth: '100%', playerHeight: '200'
            });

            $("body").on('zmp-yt-apiready', function () {
                $(".zmpcm-feed .zmp-yt-player").trigger("zmp-yt-addplayer");
            });

            $(".zmpcm-feed").on("zmp-feed-lazyloaded zmp-feed-item-refreshed zmp-feed-reinitialized", function () {
                $(".zmpcm-feed .zmp-yt-player").trigger("zmp-yt-addplayer");
            });
        }

    });


}
